import AxiosService from "./axiosServices";
import AxiosServiceWithToken from "./axiosServiceToken";
const axiosServiceWithToken = new AxiosServiceWithToken();
const axiosService = new AxiosService();
export default class AdministratorService {
  getManageGroupList = () => {
    return axiosService.Get(`api/manage-groups/`);
  };

  getUsersByGroup = (groupName) => {
    const data = {
      group_name: groupName,
    };
    return axiosService.Post(`api/get-user-by-group/`, data);
  };

  addNewGroup = (data) => {
    return axiosService.Post(`api/manage-groups/`, data);
  };

  deleteGroup = (data) => {
    return axiosService.Delete(`api/group-detail/${data}/`, true);
  };

  updateGroup = (data, id) => {
    return axiosService.Put(`api/group-detail/${id}/`, data, true);
  };

  //FOR MANAGE USER
  getUserList = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
    };
    return axiosService.Get(`api/manage-users/`, {
      params: params,
    });
  };

  addNewUser = (data) => {
    return axiosService.Post(`api/manage-users/`, data);
  };

  deleteUser = (data) => {
    return axiosService.Delete(`api/user-detail/${data}/`, true);
  };

  editUser = (data, id) => {
    return axiosService.Put(`api/user-detail/${id}/`, data, true);
  };

  getDeletedData = (obj) => {
    const { formattedStartDate, formattedEndDate } = obj;
    const params = {
      deleted_after: formattedStartDate,
      deleted_before: formattedEndDate,
    };
    return axiosService.Get(`api/get-deletion-report-list/`, {
      params: params,
    });
  };

  getManageOutput = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
      file_type: data?.fileType,
      status: data?.status,
      created_after: data?.formattedStartDate,
      created_before: data?.formattedEndDate,
      ...(data?.type !== null && {
        [data?.type === "project" ? "project_name" : "batch_name"]: data?.value,
      }),
      file_name: data?.fileNames,
    };
    return axiosService.Get(`api/list-output-files/`, {
      params: params,
    });
  };

  getManageOutputUrl = (data) => {
    return axiosService.Get(`api/preview-output-file/${data}/`);
  };

  submitOutputUpload = (id) => {
    const data = { body: { id: id } };
    return axiosService.Post(`api/approve-data-extraction/ `, data);
  };

  rejectoutputFileBatch = (data) => {
    const data1 = {
      body: {
        batch_id: data.batch_id,
        projectId: data.projectId,
        rejection_remark: data.rejection_remark,
        id: data.id,
      },
    };
    return axiosService.Post(`api/reject-batch/`, data1);
  };

  getBatchRecordType = () => {
    return axiosService.Get(`api/list-all-box-dirs/`);
  };

  uploadClientData = (data) => {
    const { file_type } = data.body;
    return axiosService.Post(
      `api/upload-client-data/?file_type=${file_type}`,
      data,
    );
  };

  getDrugTypeList = () => {
    return axiosService.Get(`api/get-drug-types/`);
  };

  // getProductTypeSubFolder = (data) => {
  //   return axiosService.Get(`api/list-box-dir/?folder_id=${data}`);
  // };

  getBatchDetailsList = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
    };
    return axiosService.Get(`api/get-batch-status/`, {
      params: params,
    });
  };

  getBatchRecordList = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
    };
    return axiosService.Get(`api/list-batch-records/`, {
      params: params,
    });
  };

  //audit trail list....
  getAuditTrailList = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
    };
    return axiosService.Get(`api/audit-trail-list/`, {
      params: params,
    });
  };

  getAuditDetails = (project_id, batch_id) => {
    const params = {
      project_id: project_id,
      batch_id: batch_id,
    };
    return axiosService.Get(`api/get-audit-trails/`, {
      params: params,
    });
  };

  getManageGroup = () => {
    return axiosService.Get(`api/manage-groups/`);
  };

  getUserActivity = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
      before: data?.before,
      after: data?.after,
      user_name: data?.user_name,
      group_name: data?.group_name,
    };
    return axiosService.Get(`api/get-user-activities/`, {
      params: params,
    });
  };

  getDataCalculation = (id) => {
    return axiosService.Get(`api/get-data-to-calculate-dp/${id}/`, {});
  };

  calculateDataPoints = (data) => {
    const data1 = {
      body: {
        id: data?.id,
        capture_effort: data?.fileName,
        capture_and_copy_effort: data?.fileName1,
        underscores_used: data?.fileName2,
      },
    };
    return axiosService.Post(`api/calculate-data-points/`, data1);
  };

  getDpDetails = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
      updated_after: data?.formattedStartDate,
      updated_before: data?.formattedEndDate,
      file_type: data?.file,
    };
    return axiosService.Get(`api/get-data-point-details/`, {
      params: params,
    });
  };

  getMergeProjectList = () => {
    return axiosService.Get(`api/get-validated-projects/`, {});
  };

  getMergeProjectBatches = (id) => {
    return axiosService.Get(`api/get-project-batches/${id}/`, {});
  };

  submitFinalOpFilesData = (data) => {
    const body = [];
    data.data.map((batch) => {
      let idOfBatches = [];

      batch?.batches.map((batchDetails, i) => {
        idOfBatches = [...idOfBatches, batchDetails?.id];
      });
      body.push({
        sheet_name: batch?.projName,
        files: idOfBatches,
      });
    });

    const dataToSubmit = {
      body: body,
      master_file_name: data?.masterFileName,
    };
    return axiosService.Post(`api/merge-batch-files/`, dataToSubmit);
  };

  mergePdfFiles = (data) => {
    return axiosService.Post(`api/merge-pdfs/`, data);
  };

  createTemplates = (data) => {
    return axiosService.Post(`api/create-template/`, data);
  };

  getMergedFiles = () => {
    return axiosService.Get(`api/merged-files/`, {});
  };
  getAuditHistoryDetail = (projectId, batchId) => {
    const params = {
      project_id: projectId,
      batch_id: batchId,
    };
    return axiosService.Get(`api/get-data-history-details/`, {
      params: params,
    });
  };

  getFilesDataForVisualization = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
    };

    return axiosService.Get(`api/approved-files-list/`, { params: params });
  };

  submitForVisualization = (data) => {
    const data1 = {
      body: {
        file_id: data.file_id,
        file_name: data.file_name,
        table_name: data.table_name,
      },
    };
    return axiosService.Post(`api/visualization/import-box-data/`, data1);
  };

  getBatchRejectedDataForColInsertion = (data) => {
    return axiosService.Get(`api/pending-batches-list/`, {});
  };

  submitBatchApprovelForColInsertion = (data) => {
    const data1 = {
      body: {
        batch_id_list: data,
      },
    };
    return axiosService.Patch(`api/approve-add-col-request/`, data1);
  };

  getNotifications = () => {
    return axiosService.Get(`api/notification-details/`, {});
  };

  getExtractedData = (projectId, batchId) => {
    const params = {
      project_id: projectId,
      batch_id: batchId,
      auto_extracted_data: true,
    };
    return axiosService.Get(`api/get-data-history-details/`, {
      params: params,
    });
  };
  getDataToFilter = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
      batch_id: localStorage.batch_id,
      parameter_name: data.selectedParameter,
      pdf_name: data.selectedPdf,
      out_of_range: data.outOfRange,
    };
    return axiosService.Get(`api/get-data-to-filter/`, {
      params: params,
    });
  };
  getExtractionDataToFilter = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
      batch_id: data?.batchId,
    };
    return axiosService.Get(`api/get-dropdown-values/`, {
      params: params,
    });
  };

  submitForRegenerateVisualizationResult = (id) => {
    const obj = {
      body: {
        id: id,
      },
    };
    return axiosService.Put(`api/visualization/regenerate-response/`, obj);
  };

  addNewVisualizationTableName = (data) => {
    const obj = {
      table_name: data.table_name,
      created_by: "CPVAdmin",
      user_id: 11,
    };
    return axiosServiceWithToken.Post(`api/visualization/table-details/`, obj);
  };
  getVisualizationTableName = () => {
    const obj = {};
    return axiosServiceWithToken.Get(`api/visualization/table-details/`, obj);
  };
  getVisualizationBoxData = () => {
    return axiosService.Get(`api/visualization/list-files-for-visualization/`);
  };

  // getAllProjectNames = () => {
  //   return axiosService.Get(`api/reports/projects-list/`);
  // };

  // getAllBatchNames = (projectId) => {
  //   return axiosService.Get(`api/reports/batch-list/${projectId}/`);
  // };

  // getAllMBRNames = (projectId, batchId) => {
  //   const params = {
  //     ...(projectId && { project_id: projectId }),
  //     ...(batchId && { batch_id: batchId }),
  //   };
  //   return axiosService.Get(`api/reports/batch-records-list/`, {
  //     params: params,
  //   });
  // };

  // getAllUserGroupAndNames = () => {
  //   return axiosService.Get(`api/reports/users-list/`);
  // };

  // getAllParameters = (projectId) => {
  //   return axiosService.Get(`api/reports/project-parameters/${projectId}/`);
  // };

  // getFilteredData = (data) => {
  //   const params = {
  //     page_size: data?.page_size || "",
  //     page: data?.page || "",
  //     project_name: data?.filters?.projectName || "",
  //     batch_name: data?.filters?.batchName || "",
  //     user_name: data?.filters?.userName || "",
  //     user_group: data?.filters?.userGroupName || "",
  //     date_min: data?.filters?.dateRange?.[0] || "",
  //     date_max: data?.filters?.dateRange?.[1] || "",
  //     parameter_name: data?.filters?.parameterName || "",
  //     mbr_name: data?.filters?.mbrName,
  //   };
  //   return axiosServiceWithToken.Get(`api/reports/logs-list/`, {
  //     params: params,
  //   });
  // };

  // getDataForExport = (data) => {
  //   const params = {
  //     page_size: data?.page_size || "",
  //     page: data?.page || "",
  //     project_name: data?.filters?.projectName || "",
  //     batch_name: data?.filters?.batchName || "",
  //     user_name: data?.filters?.userName || "",
  //     user_group: data?.filters?.userGroupName || "",
  //     date_min: data?.filters?.dateRange?.[0] || "",
  //     date_max: data?.filters?.dateRange?.[1] || "",
  //     parameter_name: data?.filters?.parameterName || "",
  //     mbr_name: data?.filters?.mbrName,
  //   };
  //   return axiosServiceWithToken.Get(`api/reports/logs-list/`, {
  //     params: params,
  //   });
  // };

  getPdfLink = (data) => {
    return axiosService.Post(`api/reports/generate-log-report-pdf/`, {
      data: data,
    });
  };

  restoreHistoryData = (data) => {
    const body = {
      body: {
        batch_id: data.batch_id,
        obj_id: data.obj_id,
      },
    };
    return axiosService.Post(`api/restore-data/`, body);
  };
  listHistoryData = (data) => {
    return axiosService.Get(`api/list-data-history/${data}/`);
  };
  getPreviewHistoryData = (data) => {
    // const body = {
    //   batch_id: data,
    // };
    return axiosService.Get(`api/preview-history-data/${data.obj_id}/`);
  };

  handleDeletePdf = (id) => {
    return axiosService.Delete(`api/delete-failed-document/${id}/`);
  };

  userStatus = (data) => {
    return axiosService.Put(`api/change-user-status/${data.id}/`);
  };

  refreshBoxFolders = () => {
    return axiosService.Get(`api/refresh-box-cache/`, {});
  };

  deleteBatchLogs = (id) => {
    return axiosService.Delete(`api/delete-batch/${id}/`);
  };

  deleteProjectLogs = (id) => {
    return axiosService.Delete(`api/delete-project/${id}/`);
  };

  submitFilesForSRM = (ids) => {
    const data = { body: { file_ids: ids } };

    return axiosService.Post(`api/submit-to-srm/`, data);
  };
}
